// extracted by mini-css-extract-plugin
module.exports = {"mainFeed":"feed_mainFeed__20mZr"};